import { Org360Layout } from "@/components/organisms/org360/Org360Layout";

export function Org360Page() {
  return (
    <div className="w-full h-full">
      <Org360Layout />
    </div>
  );
}

export default Org360Page;
